<template>
    <section>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="addFormVisible=true">Add a payment method</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table stripe :data="list" highlight-current-row v-loading="listLoading" @selection-change="" style="width: 100%;">
            <el-table-column label="#" prop="bankNo">
            </el-table-column>
            <el-table-column prop="category" label="Category" >
            </el-table-column>
            <el-table-column prop="currency" label="Currency" >
            </el-table-column>
            <el-table-column prop="accountNumber" label="Account Number" >
            </el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button size="small" @click="showEditBank(scope.row.bankNo)">Edit</el-button>
                    <el-button type="danger" size="small" @click="deleteBank(scope.row.bankNo)">Delete</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pageSize" :total="total"
                           style="float:right;">
            </el-pagination>
        </el-col>


        <!--新增界面-->
        <el-dialog title="Add a payment method" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="payment" label-width="180px" :rules="addFormRules" ref="payment">
                <el-form-item label="Category" prop="category">
                    <el-select v-model="payment.category" clearable auto-complete="off">
                        <el-option
                                v-for="item in categoryOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Currency" prop="currency">
                    <el-select v-model="payment.currency" clearable auto-complete="off">
                        <el-option
                                v-for="item in currencyOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="payment.category">
                    <el-form-item :label="payment.category=='Bill Pay'?'Credit card company':'Bank Name'" prop="company">
                        <el-input type="text" v-model="payment.company"></el-input>
                        <p class="note" v-if="payment.category=='Bill Pay'">E.g., Chase, Bank of America, Wells Fargo,
                            U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,
                            Target.</p>
                        <p class="note" v-else>E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.</p>
                    </el-form-item>
                    <el-form-item :label="payment.category=='Bill Pay'?'Card network':'Account type'" prop="accountType">
                        <el-input type="text" v-model="payment.accountType"></el-input>
                        <p class="note" v-if="payment.category=='Bill Pay'">E.g., Visa, MasterCard, American Express,
                            Discover, Store credit card.</p>
                        <p class="note" v-else>E.g., Checking, Saving.</p>
                    </el-form-item>
                    <el-form-item label="Account holder" prop="accountHolder">
                        <el-input type="text" v-model="payment.accountHolder"></el-input>
                    </el-form-item>
                    <el-form-item label="Account number" prop="accountNumber">
                        <el-input type="text" v-model="payment.accountNumber"></el-input>
                    </el-form-item>
                    <el-form-item
                            :label="payment.category=='Bill Pay'?'Bank address (PO box)':'Account holder\'s address'"
                            prop="bankAddress">
                        <el-input type="textarea" rows="5" v-model="payment.bankAddress"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="addBank" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Edit payment method" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editPayment" label-width="180px" :rules="addFormRules" ref="editPayment">
                <el-form-item label="Category" prop="category">
                    <el-select v-model="editPayment.category" clearable auto-complete="off">
                        <el-option
                                v-for="item in categoryOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Currency" prop="currency">
                    <el-select v-model="editPayment.currency" clearable auto-complete="off">
                        <el-option
                                v-for="item in currencyOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="editPayment.category">
                    <el-form-item :label="editPayment.category=='Bill Pay'?'Credit card company':'Bank Name'" prop="company">
                        <el-input type="text" v-model="editPayment.bankName"></el-input>
                        <p class="note" v-if="editPayment.category=='Bill Pay'">E.g., Chase, Bank of America, Wells Fargo,
                            U.S. Bank, Citibank, Captial One, PNC, BarclayCard US, Staples, Office Depot, Dell,
                            Target.</p>
                        <p class="note" v-else>E.g., Chase, Bank of America, Wells Fargo, Citibank, PNC.</p>
                    </el-form-item>
                    <el-form-item :label="editPayment.category=='Bill Pay'?'Card network':'Account type'" prop="accountType">
                        <el-input type="text" v-model="editPayment.accountType"></el-input>
                        <p class="note" v-if="editPayment.category=='Bill Pay'">E.g., Visa, MasterCard, American Express,
                            Discover, Store credit card.</p>
                        <p class="note" v-else>E.g., Checking, Saving.</p>
                    </el-form-item>
                    <el-form-item label="Account holder" prop="accountHolder">
                        <el-input type="text" v-model="editPayment.accountHolder"></el-input>
                    </el-form-item>
                    <el-form-item label="Account number" prop="accountNumber">
                        <el-input type="text" v-model="editPayment.accountNumber"></el-input>
                    </el-form-item>
                    <el-form-item
                            :label="editPayment.category=='Bill Pay'?'Bank address (PO box)':'Account holder\'s address'"
                            prop="bankAddress">
                        <el-input type="textarea" rows="5" v-model="editPayment.bankAddress"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editBank" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
    </section>
</template>


<script>
    import util from '../../common/js/util'
    //import NProgress from 'nprogress'
    import {defaultPageSize} from "../../globalVar";
    import {getNurseBanks,deleteNurseBanks,addBanks,queryBankById} from '../../api/paymentService';

    export default {
        data() {
            return {
                categoryOption: [{
                    value: 'Bill Pay',
                    label: 'Bill Pay'
                }, {
                    value: 'Bank Transfer',
                    label: 'Bank Transfer'
                }],
                currencyOption: [{
                    value: 'USD',
                    label: 'United States Dollar'
                }, {
                    value: 'CNY',
                    label: 'China Yuan Renminbi'
                }, {
                    value: 'BTC',
                    label: 'Bitcoin'
                }],
                filters: {
                    name: ''
                },
                list: [],
                page:1,
                pageSize:defaultPageSize,
                total: 0,
                loading:false,
                listLoading: false,
                sels: [],//列表选中列

                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ]
                },

                addFormVisible: false,//新增界面是否显示
                addFormRules: {
                    category: [
                        {required: true, message: 'Category is required.', trigger: 'blur'}
                    ],
                    currency: [
                        {required: true, message: 'Currency is required.', trigger: 'blur'}
                    ],
                    accountNumber: [
                        {required: true, message: 'Account Number is required.', trigger: 'blur'}
                    ]
                },
                //新增界面数据
                payment: {
                    category: '',
                    currency: '',
                    bankName: '',//Credit card company for bill pay,Bank name for bank transfer.
                    accountType: '',//Card network for bill pay,Account type for bank transfer
                    accountHolder: '',
                    accountNumber: '',
                    bankAddress: '',
                },
                editPayment: {
                    bankNo: '',
                    category: '',
                    currency: '',
                    bankName: '',//Credit card company for bill pay,Bank name for bank transfer.
                    accountType: '',//Card network for bill pay,Account type for bank transfer
                    accountHolder: '',
                    accountNumber: '',
                    bankAddress: '',
                }

            }
        },
        methods: {
            showEditBank(id){
                queryBankById({bankNo:id}).then((res)=>{
                    if(res.status===200){
                        this.editPayment= res.result.bank;
                        this.editFormVisible = true;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            editBank(){
                this.$refs.editPayment.validate((valid)=>{
                    if(valid){
                        let params = {
                            bankNo:this.editPayment.bankNo,
                            category:this.editPayment.category,
                            currency:this.editPayment.currency,
                            bankName:this.editPayment.bankName,
                            accountType:this.editPayment.accountType,
                            accountHolder:this.editPayment.accountHolder,
                            accountNumber:this.editPayment.accountNumber,
                            bankAddress:this.editPayment.bankAddress
                        };
                        this.loading = true;
                        addBanks(params).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.$refs.editPayment.resetFields();
                                this.editFormVisible = false;
                                this.getNursePayments();
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                });
                            }
                        }).catch((err)=>{
                            console.log(err);
                            this.loading = false;
                        })
                    }
                })
            },
            addBank(){
                this.$refs.payment.validate((valid)=>{
                    if(valid){
                        let params = {
                            category:this.payment.category,
                            currency:this.payment.currency,
                            bankName:this.payment.bankName,
                            accountType:this.payment.accountType,
                            accountHolder:this.payment.accountHolder,
                            accountNumber:this.payment.accountNumber,
                            bankAddress:this.payment.bankAddress
                        };
                        this.loading = true;
                        addBanks(params).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.$refs.payment.resetFields();
                                this.addFormVisible = false;
                                this.getNursePayments();
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                });
                            }
                        }).catch((err)=>{
                            console.log(err);
                            this.loading = false;
                        })
                    }
                })
            },
            pageChange(val){
                this.page = val;
                this.getNursePayments();
            },
            deleteBank(id){
                this.$confirm("Are you sure?","Warning",{
                    type:"warning"
                }).then(()=>{
                    deleteNurseBanks({bankNo:id}).then((res)=>{
                        if(res.status===200){
                            this.$message({
                                message:res.message,
                                type:"success"
                            });
                            this.getNursePayments();
                        }else{
                            this.$message({
                                message:res.message,
                                type:"error"
                            });
                        }
                    })
                }).catch(()=>{

                })
            },
            getNursePayments() {
                this.listLoading = true;
                let params = {
                    current:this.page,
                    size:this.pageSize,
                    condition:this.filters.name
                };
                getNurseBanks(params).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.list = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message:res.message,
                            type:'error'
                        })
                    }

                }).catch(err=>{
                    this.listLoading = false;
                    console.log(err);
                })
            }
        },
        mounted() {
            this.getNursePayments();
        }
    }

</script>


// WEBPACK FOOTER //
// bank.vue?5c15b706